import { render, staticRenderFns } from "./TempoExpiradoCliente.vue?vue&type=template&id=0ecfc6ed&"
import script from "./TempoExpiradoCliente.vue?vue&type=script&lang=js&"
export * from "./TempoExpiradoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports